import React, { Component } from 'react';
import "../BottomCal/bottom-cal.css";
import calculator from "../../icons/calculator.svg";
import rent from "../../icons/rent.svg";

class BottomCal extends Component {
    render() {
        return (
            <React.Fragment>
                <div class="bottom-calc-main-container">
                    <h3>Other home loan tools and calculators</h3>
                    <div className="bottom-calc-link-container">
                        <div class="bottom-calc-link-box">
                            <a class="bottom-calc-link" href="/calculators/home-loan-repayment/">
                                <div>
                                    <div class="bottom-calc-img-container">
                                    <img class="bottom-calc-icon" src={calculator} alt="calculator"/>
                                    </div>
                                    <div class="bottom-calc-content-container">
                                        <p class="bottom-calc-link-header">Repayment Calculator<span class="chevron">></span></p>
                                        <p class="bottom-calc-link-content">Calculate your home loan repayments and savings when you make extra payments to your mortgage.</p>
                                    </div>
                                    
                                </div>
                            </a>
                        </div>
                        <div class="bottom-calc-link-box">
                            <a class="bottom-calc-link" href="/calculators/home-loan-borrowing-power/">
                                <div>
                                    <div class="bottom-calc-img-container">
                                    <img class="bottom-calc-icon" src={calculator} alt="calculator"/>
                                    </div>
                                    <div class="bottom-calc-content-container">
                                        <p class="bottom-calc-link-header">Borrowing Power Calculator<span class="chevron">></span></p>
                                        <p class="bottom-calc-link-content">Find out your affordability and how much you may be eligible to borrow with HSBC Australia.</p>
                                    </div>
                                    
                                </div>
                            </a>
                        </div>
						<div class="bottom-calc-link-box">
                            <a class="bottom-calc-link" href="/calculators/home-loans-key-fact-sheet/">
                                <div>
                                    <div class="bottom-calc-img-container">
                                        <img class="bottom-calc-icon" src={calculator} alt="calculator"/>
                                    </div>
                                    <div class="bottom-calc-content-container">
                                        <p class="bottom-calc-link-header">Home Loan Key Facts Sheet<span class="chevron">></span></p>
                                        <p class="bottom-calc-link-content">All information about a home loan you can save and print to compare between banks.</p>
                                    </div>
                        
                                </div>
                            </a>
                        </div>
                        <div class="bottom-calc-link-box" id="right">
                            <a class="bottom-calc-link" href="/home-loans/">
                                <div>
                                    <div class="bottom-calc-img-container">
                                        <img class="bottom-calc-icon" src={rent} alt="rent"/>
                                    </div>
                                    <div class="bottom-calc-content-container">
                                        <p class="bottom-calc-link-header">View HSBC Home Loan Products<span class="chevron">></span></p>
                                        <p class="bottom-calc-link-content">Browse HSBC Home Loan products based on your mortgage needs.</p>
                                    </div>
                                    
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default BottomCal;